<template>
  <div class="content">

    <!-- 筛选 -->
    <div style="overflow: hidden">
      <el-input v-model="input1"
                placeholder="请输入产品编号"
                style="width:300px;margin-right: 20px;float: left"
                clearable>
        <el-button slot="append"
                   icon="el-icon-search"
                   @click="loadFormData" />
      </el-input>
      <el-input v-model="input2"
                placeholder="请输入产品名称"
                style="width:300px;margin-right: 20px;float: left"
                clearable>
        <el-button slot="append"
                   icon="el-icon-search"
                   @click="loadFormData" />
      </el-input>
      <el-select v-model="value"
                 placeholder="请选择"
                 @change="loadFormData"
                 style="float: left">
        <el-option v-for="item in options"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
      <el-button @click="handleAdd"
                 type="success"
                 size="medium"
                 icon="el-icon-circle-plus-outline"
                 class="addBtn">
        添加配置
      </el-button>
    </div>
    <!-- 表格 -->
    <el-table
        v-loading="loading"
      :data="tableData"
      ref="table"
      :key="tableKey"
      style="margin: 10px 0 15px 0;"
      :height="tableHt"
      border
      size="small"
      :highlight-current-row="true">
      <el-table-column label="序号"
                       type="index"></el-table-column>
      <el-table-column label="产品名称"
                       width="130"
                       prop="fProductname"
                       align="center" />
      <el-table-column label="产品编号"
                       width="130"
                       prop="fProductid"
                       align="center" />
      <el-table-column label="区划名称"
                       width="130"
                       prop="fRegionname"
                       align="center" />
      <el-table-column label="服务地址"
                       prop="fServerurl"
                       align="left"
                       header-align="center"
                       :show-overflow-tooltip="true" />
      <el-table-column label="logo"
                       prop="fIcon"
                       align="center"
                       width="80"
                       header-align="center"
                       :show-overflow-tooltip="false">
        <template slot-scope="scope">
          <el-avatar v-if="scope.row.fIcon" shape="square" :size="40" fit="fill" :src="'data:image/jpeg;base64,'+ scope.row.fIcon"></el-avatar>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <!--<el-table-column label="服务状态" width="80" >
      <template slot-scope="scope">
        <el-tag v-if="scope.row.fState!=1" type="danger" size="small">异常</el-tag>
        <el-tag v-if="scope.row.fState==1" type="success" size="small">正常</el-tag>
      </template>
      </el-table-column> -->
      <el-table-column label="运行环境"
                       width="100"
                       align="center"
                       prop="fEnv"
                       :filters="[{ text: '正式环境', value: 1 }, { text: '测试环境', value: 0 }]"
                       :filter-multiple="false"
                       filter-placement="bottom-end"
                       :filter-method="filterevn">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.fEnv==0"
                  type="success"
                  size="small">测试环境
          </el-tag>
          <el-tag v-if="scope.row.fEnv==1"
                  type="danger"
                  size="small">正式环境
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       width="300"
                       align="center">
        <template slot-scope="scope">
          <el-button size="mini"
                     type="info"
                     @click="handleDetil(scope.$index, scope.row)">详情
          </el-button>
          <el-button size="mini"
                     type="primary"
                     @click="handleEdit(scope.$index, scope.row)">编辑
          </el-button>
          <el-button size="mini"
                     type="info"
                     @click="handleLog(scope.$index, scope.row)">日志
          </el-button>
          <el-button size="mini"
                     type="danger"
                     @click="handleDelete(scope.$index, scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div style="display: flex;justify-content: center;padding: 10px">
      <el-pagination
        background
        layout="total,prev, pager, next, jumper"
        :total="configData.total"
        :current-page.sync="configData.curPage"
        @current-change="handlePageChange"></el-pagination>
    </div>

    <!-- 编辑添加 -->
    <el-dialog :title="title"
               :visible.sync="editDlg">
      <el-form :inline="true"
               :model="curAppConfig"
               label-width="80px"
               v-if="editDlg"
               style="text-align:left">
        <el-form-item label="区划名称"
                      :rules="{required: true, message: '区域不能为空', trigger: 'blur'}">
          <div class="regionPane">
            <el-scrollbar class="scrollpane">
              <el-tree :props="treeProp"
                       :accordion="true"
                       :load="loadNode"
                       lazy
                       class="tree"
                       ref="tree">
                <span class="custom-tree-node"
                      slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                  <span style="position:absolute;right:10px;">
                    <el-button type="text"
                               @click.stop="_=>selectRegion(data)">选择</el-button>
                  </span>
                </span>
              </el-tree>
            </el-scrollbar>
          </div>
        </el-form-item>
        <br>
        <el-form-item label="运行环境"
                      :rules="{required: true, message: '请选择环境', trigger: 'blur'}">
          <el-select v-model="curAppConfig.fEnv"
                     style="width:262px">
            <el-option label="正式环境"
                       :value="1"></el-option>
            <el-option label="测试环境"
                       :value="0"></el-option>
          </el-select>
        </el-form-item>
        <br>
        <el-form-item label="产品编号"
                      :rules="{required: true, message: '产品编号不能为空', trigger: 'blur'}">
          <el-input v-model="curAppConfig.fProductid"
                    :readonly="!!curAppConfig.fId"
                    placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="产品名称"
                      :rules="{required: true, message: '产品名称不能为空', trigger: 'blur'}">
          <el-input v-model="curAppConfig.fProductname"
                    placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="服务地址"
                      :rules="{required: true, message: '服务地址不能为空', trigger: 'blur'}">
          <el-input v-model="curAppConfig.fServerurl"
                    style="width:500px"></el-input>
        </el-form-item>
        <br>
        <el-form-item label="测试地址"
                      :rules="{required: true, message: '测试地址不能为空', trigger: 'blur'}">
          <el-input v-model="curAppConfig.fTesturl"
                    style="width:500px"></el-input>
        </el-form-item>
        <br>
        <el-form-item label="管理员">
          <el-input v-model="curAppConfig.fManager"
                    placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="curAppConfig.fManagertel"
                    placeholder=""></el-input>
        </el-form-item>
        <br>
        <el-form-item label="Logo">
<!--          <el-avatar shape="square" :size="100" fit="fill" :src="'data:image/jpeg;base64,'+ curAppConfig.fIcon"></el-avatar>-->
<!--          <img :src=" 'data:image/jpeg;base64,' + curAppConfig.fIcon" alt="logo">-->

          <el-upload
              class="avatar-uploader"
              action=""
              :auto-upload="false"
              :show-file-list="false"
              :on-change="fileChange"
              :multiple="false"
              :before-upload="beforeAvatarUpload">
<!--            <img v-if="curAppConfig.fIcon" :src="'data:image/jpeg;base64,'+ curAppConfig.fIcon" class="avatar">-->
            <el-avatar v-if="curAppConfig.fIcon" shape="square" :size="100" fit="fill" :src="'data:image/jpeg;base64,'+ curAppConfig.fIcon"></el-avatar>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editDlg = false">取 消</el-button>
        <el-button type="primary"
                   @click="handleSave">保 存</el-button>
      </span>
    </el-dialog>

    <!-- 日志页 -->
    <el-dialog title="日志"
               :visible.sync="log"
               width="500px"
               top="20px"
               style="text-align:center">
      <el-table :data="logData.data"
                style="width:400px;display:inline-block"
                size="mini">
        <el-table-column label="序号"
                         width="100"
                         type="index"
                         align="center" />
        <el-table-column label="服务状态"
                         width="100"
                         align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.fState!=1"
                    type="danger"
                    size="mini">异常
            </el-tag>
            <el-tag v-if="scope.row.fState==1"
                    type="success"
                    size="mini">正常
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="变化时间"
                         width="200"
                         prop="fUpdatetime"
                         align="center"
                         :formatter="formaTime" />
      </el-table>
      <el-pagination style="display: flex;justify-content: center"
                     layout="prev, pager, next"
                     :page-count="logData.pageTotal"
                     :current-page.sync="logData.curPage"
                     @current-change="logPageChange"
                     :small="true"
                     :page-size="logData.pageSize"></el-pagination>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   size="small"
                   @click="log = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 详情页 -->
    <el-dialog title="详情"
               :visible.sync="detil"
               width="700px">
      <div class="detil">
        <el-row>
          <el-col :span="3">
            <el-tag>产品名称：</el-tag>
          </el-col>
          <el-col :span="7"
                  :offset="1">
            <el-tag type="info">{{ curAppConfig.fProductname }}</el-tag>
          </el-col>
          <el-col :span="3"
                  :offset="2">
            <el-tag>产品编号：</el-tag>
          </el-col>
          <el-col :span="7"
                  :offset="1">
            <el-tag type="info">{{ curAppConfig.fProductid }}</el-tag>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-tag>区划名称：</el-tag>
          </el-col>
          <el-col :span="7"
                  :offset="1">
            <el-tag type="info">{{ curAppConfig.fRegionname }}</el-tag>
          </el-col>
          <el-col :span="3"
                  :offset="2">
            <el-tag>区划编码：</el-tag>
          </el-col>
          <el-col :span="7"
                  :offset="1">
            <el-tag type="info">{{ curAppConfig.fRegioncode }}
            </el-tag>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-tag>服务地址：</el-tag>
          </el-col>
          <el-col :span="20"
                  :offset="1">
            <el-tag type="info">{{ curAppConfig.fServerurl }}
            </el-tag>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-tag>测试地址：</el-tag>
          </el-col>
          <el-col :span="20"
                  :offset="1">
            <el-tag type="info">{{ curAppConfig.fTesturl }}</el-tag>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-tag>管理员：</el-tag>
          </el-col>
          <el-col :span="7"
                  :offset="1">
            <el-tag type="info">{{ curAppConfig.fManager }}
            </el-tag>
          </el-col>
          <el-col :span="3"
                  :offset="2">
            <el-tag>联系方式：</el-tag>
          </el-col>
          <el-col :span="7"
                  :offset="1">
            <el-tag type="info">{{ curAppConfig.fManagertel }}
            </el-tag>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-tag>创建时间：</el-tag>
          </el-col>
          <el-col :span="7"
                  :offset="1">
            <el-tag type="info"> {{ curAppConfig.fCreatetime }}</el-tag>
          </el-col>
          <el-col :span="3"
                  :offset="2">
            <el-tag>运行环境：</el-tag>
          </el-col>
          <el-col :span="7"
                  :offset="1">
            <el-tag type="info">{{ curAppConfig.fEnv ? "正式环境" : "测试环境" }}
            </el-tag>
          </el-col>
        </el-row>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   size="small"
                   @click="detil = false">关 闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import util from "../lib/util.js";
import MonitorService from "../Service/MonitorService.js";
import { debug } from "util";
import Login from "@/views/login.vue";

export default {
  name: "monitor",
  components: {},
  data() {
    return {
      loading:false,
      title: "",
      editDlg: false,
      detil: false,
      log: false,
      curAppConfig: {
        fIcon:''
      },
      tableData: [],
      tableKey: Math.random().toString(),
      configData: { id: 0, pageSize: 20, curPage: 1, total: 1 },
      logData: { data: [], pageSize: 10, curPage: 1, pageTotal: 1 },
      timer: null,
      refreshInterval: 10000, //刷新时间间隔
      treeProp: {
        label: "fName",
        children: "",
        isLeaf: "leaf"
      },
      value: null,
      options: [
        {
          label: "全部"
        },
        {
          value: "0",
          label: "测试环境"
        },
        {
          value: "1",
          label: "正式环境"
        }
      ],
      input1: null,
      input2: null,
      imageUrl: ''
    };
  },
  computed: {
    isAnyDlg() {
      return this.editDlg || this.detil || this.log;
    },
    tableHt() {
      return "calc(100vh - 190px)";
    }
  },

  watch: {
    isAnyDlg: function(newVal, oldVal) {
      if (newVal) {
        window.clearInterval(this.timer);
      } else {
        this.startTimer();
      }
    }
  },

  mounted() {
    this.loadFormData();
    this.startTimer();
  },

  methods: {
    filterevn(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },

    /* ------------ 按钮点击响应方法开始  ------------*/
    handleDetil(index, data) {
      this.curAppConfig = Object.assign({}, data);
      this.curAppConfig.fCreatetime = util.formatDateTime(this.curAppConfig.fCreatetime);
      this.detil = true;
    },

    handleEdit(index, data) {
      this.title = "编辑";
      this.curAppConfig = Object.assign({}, data);
      this.editDlg = true;
    },

    handleLog(index, data) {
      this.curAppConfig = Object.assign({}, data);
      this.logData.id = data.fId;
      this.loadLogData();
      this.log = true;
    },

    handleDelete(index, data) {
      this.$confirm("此操作将删除该配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        util
          .delete(`/appconfig/t/appconfig/${data.fId}`)
          .then((r) => {
            if (r.data.code === 200) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.loadFormData();
            } else {
              this.$message.error(r.data.message);
            }
          })
          .catch((r) => this.$message.error(r.data.message));
      });
    },

    handleAdd() {
      this.curAppConfig = {};
      this.title = "添加";
      this.editDlg = true;
    },

    handleSave() {
      if (!this.curAppConfig.fRegioncode) {
        this.$message.error("区划不能为空");
        return;
      }
      if (!this.curAppConfig.fProductid) {
        this.$message.error("产品编号不能为空");
        return;
      }
      if (!this.curAppConfig.fServerurl) {
        this.$message.error("服务地址不能为空");
        return;
      }
      if (!this.curAppConfig.fTesturl) {
        this.$message.error("测试地址不能为空");
        return;
      }
      this.title === "编辑" ? this.saveEdit() : this.addConfig();
    },

    handlePageChange() {
      this.loadFormData();
    },

    logPageChange() {
      this.loadLogData();
    },

    /* ------------- 按钮点击响应方法结束 -------------*/

    // 修改AppConfig数据
    saveEdit() {
      util.update("/appconfig/t/appconfig", this.curAppConfig).then((r) => {
        if (r.data.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success"
          });
          this.loadFormData();
          this.editDlg = false;
        } else {
          this.$message.error(r.data.message);
        }
      });
    },

    // 添加APPConfig数据
    addConfig() {
      this.curAppConfig.fCreatetime = new Date();
      util.post("/appconfig/t/appconfig", this.curAppConfig).then((r) => {
        if (r.data.code === 200) {
          this.$message({
            message: "添加成功",
            type: "success"
          });
          this.loadFormData();
          this.editDlg = false;
        } else {
          this.$message.error(r.data.message);
        }
      });
    },

    formaTime(row, column, cellValue, index) {
      return util.formatDateTime(cellValue);
    },
    // 加载appConfig表格数据
    loadFormData() {
      const that = this;
      this.loading = true;
      MonitorService.getApkList({
        page: this.configData.curPage,
        size: this.configData.pageSize,
        env: this.value,
        productId: this.input1,
        productName: this.input2
      })
        .then((r) => {
          if (r.data.code === 200) {
            that.tableData = r.data.data.list;
            that.configData.total = r.data.data.total;
            that.tableKey = Math.random().toString();
          } else {
            that.tableData = [];
            that.$message.error(r.data.message);
            console.log(r);
          }
        })
        .catch((r) => console.log(r)).finally(()=>{
          that.loading = false;
      })
    },

    loadLogData(id = this.logData.id, page = this.logData.curPage, size = this.logData.pageSize) {
      util.get("/appconfig/t/serverlog/getLogbyCongfigId?id=" + id + "&page=" + page + "&size=" + size).then((r) => {
        this.logData.data = r.data.data.list;
        this.logData.pageTotal = r.data.data.lastPage;
      });
    },

    //加载区划树节点
    loadNode(node, resolve) {
      if (node.level === 0) {
        if (this.curAppConfig.fRegionname) {
          return resolve([{ fName: this.curAppConfig.fRegionname }]);
        } else {
          return resolve([{ fName: "选择区域" }]);
        }
      }
      if (node.level == 1) {
        util.get("/appconfig/t/region/getProvince").then((r) => resolve(r.data.data));
      }
      if (node.level > 1) {
        util.get(`/appconfig/t/region/getRegionByPcode/${node.data.fCode}`).then((r) => resolve(r.data.data));
      }
    },
    // 区划树节点点击事件
    selectRegion(region) {
      this.curAppConfig.fRegionname = region.fName;
      this.curAppConfig.fRegioncode = region.fCode;
      this.$refs.tree.$children[0].node.data.fName = region.fName;
      this.$refs.tree.$children[0].$emit("node-expand");
    },

    //定时刷新AppConfig表格数据
    startTimer() {
      // this.timer = setInterval(this.loadFormData, this.refreshInterval);
    },

    fileChange(file, fileList) {
      let that = this;
      const reader = new FileReader();
      reader.onload = function(e) {
        const dataURL = e.target.result;
        const base64String = dataURL.split(',')[1];
        // that.curAppConfig.fIcon = base64String;
        that.$set(that.curAppConfig, 'fIcon', base64String);
      };
      reader.readAsDataURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    }
  }
};
</script>
<style lang="scss" scoped>
$pryClr: #3399ff;
$pryClrL: #5cadff;
$pryClrD: #3091f2;
$infoClr: #3399ff;
$successClr: #00cc66;
$wrnClr: #ff9900;
$errorClr: #ff6600;
$dividerClr: #e3e8ee;
$bgc: #f5f7f9;
$contentClr: #657180;
$titleClr: #464c5b;
$topHt: 60px;
$spbd: #d7dde4 1px solid;

.content {
  width: calc(100vw - 40px);
  height: 100%;
  padding: 20px 20px 10px 20px;
  background-color: #fff;

  .addBtn {
    display: block;
    float: right;
  }

  .top {
    font-size: 14px;
    margin-bottom: 5px;
    border: $spbd;
    padding: 4px;
  }
}

.detil {
  text-align: left;

  .value {
    margin-left: 10px;
    width: 120px;
    border: $spbd;
    border-radius: 4px;
  }

  .el-row {
    padding: 4px 0;

    .el-tag {
      display: block;
      width: 100%;
    }
  }
}

.regionPane {
  position: absolute;
  z-index: 10;
  background-color: #fff;

  .scrollpane {
    border: $spbd;
    border-radius: 5px;

    .el-scrollbar__wrap {
      overflow: scroll;
      overflow-x: auto;

      .tree {
        padding: 5px;
        width: 250px;
        max-height: 200px;
      }
    }
  }
}

::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  img{
    height: 100%;
    width: 100%;
  }
}
::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}


</style>

